import { forwardRef } from 'react';
import {
  GridDensity,
  GridToolbarContainer,
  GridToolbarContainerProps,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-pro';
import { ToggleButtonGroup, ToggleButton } from '../../mui';
import { MdFolder, MdViewList } from 'react-icons/md';

export type GroupingOption = 'grouped' | 'flat';

interface ControllerGridToolbarContainerProps extends GridToolbarContainerProps {
  showQuickFilter?: boolean;
  showGroupingSelect?: boolean;
  grouping?: GroupingOption;
  onGroupingChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: unknown) => void;
  density?: GridDensity;
}

export const ControllerGridQuickFilterToolbar = forwardRef<
  HTMLDivElement,
  ControllerGridToolbarContainerProps
>(function ControllerGridQuickFilterToolbar(props: ControllerGridToolbarContainerProps, ref) {
  const {
    density,
    grouping,
    showGroupingSelect = false,
    showQuickFilter = true,
    onGroupingChange,
    ...rest
  } = props;

  return (
    <GridToolbarContainer
      sx={{
        justifyContent: 'flex-end',
        margin: density === 'compact' ? 0 : undefined,
      }}
      ref={ref}
      {...rest}
    >
      {showGroupingSelect && (
        <ToggleButtonGroup
          value={grouping}
          size={density === 'compact' ? 'small' : undefined}
          exclusive
          onChange={onGroupingChange}
        >
          <ToggleButton value='flat'>
            <MdViewList />
          </ToggleButton>
          <ToggleButton value='grouped'>
            <MdFolder />
          </ToggleButton>
        </ToggleButtonGroup>
      )}
      {showQuickFilter && (
        <GridToolbarQuickFilter
          variant='outlined'
          size={density === 'compact' ? 'small' : undefined}
          sx={{ margin: 0 }}
        />
      )}
    </GridToolbarContainer>
  );
});
